// extracted by mini-css-extract-plugin
export default {"backdrop":"AddNewSlider_backdrop__LZbjp","z_index_100":"AddNewSlider_z_index_100__wcD8V","modal_title":"AddNewSlider_modal_title__POBuZ","BlogIcon":"AddNewSlider_BlogIcon__3wegK"};